import { useCoinwebWalletContext } from '../provider';

export const useCoinwebWallet = () => useCoinwebWalletContext();
